<template>
  <styled-nav-bar-wrap>
    <styled-tabs-wrapper
      :is-payment-method-page="isPaymentMethodPage"
      class="payment-methods__tabs-wrapper"
    >
      <!-- TODO: write another layout for flow redirect page, too much custom logic -->
      <TabsList v-if="!isMobile || (isMobile && isPaymentMethodPage)" :tabs-list="tabsList" />
      <input-search-component
        ref="searchInput"
        v-if="!isPaymentMethodPage"
        :search-value="internalSearch"
        @searchChange="_handleSearchUpdate"
      />
    </styled-tabs-wrapper>

    <styled-mobile-navigation
      v-if="isMobile && !isPaymentMethodPage"
      class="payment-methods__tabs-wrapper"
    >
      <transition name="transition-select-payment-component">
        <StyledSelectPayment v-if="!searchIsFocus" />
      </transition>
      <transition name="transition-mob-search">
        <mob-search v-if="searchIsFocus" />
      </transition>
    </styled-mobile-navigation>
  </styled-nav-bar-wrap>
</template>

<script>
import styled from 'vue-styled-components';
import { mapGetters, mapActions, mapState } from 'vuex';
import InputSearchComponent from '@/components/UI/InputSearchComponent';
import TabsList from '@/components/Header/TabsList';

import MobSearch from '@/components/UI/MobSearch';
import SelectPayment from '@/components/Header/NavigationBar/SelectPayment';
import { constants } from 'fs';

const tabsWrapperProps = {
  isPaymentMethodPage: Boolean,
};

const styledNavBarWrap = styled.section`
  width: 100%;
`;

const styledTabsWrapper = styled('div', tabsWrapperProps)`
  width: 100%;
  @media screen and (max-width: 420px) {
    padding: ${props => (props.isPaymentMethodPage ? '0 20px' : '0')};
  }
`;

const styledMobileNavigation = styled('div', tabsWrapperProps)`
  display: flex;
  justify-content: space-between;
`;

const styledSelectPayment = styled(SelectPayment)`
  background: var(--surface);
  width: 100%;

  .select-payment {
    padding: 10px;
  }
  span {
    padding: 10px;
  }
`;

export default {
  data() {
    return {
      internalSearch: '123',
      searchIsFocus: false,
    };
  },

  watch: {
    searchData(value) {
      if (value === null && this.$refs.searchInput) {
        this.$refs.searchInput.clearInput();
      }
    },
  },
  created() {
    this.$bus.$on('searchClick', $event => {
      this.searchIsFocus = $event ? true : false;
    });
  },

  computed: {
    ...mapState(['categories', 'navigationData', 'searchData']),
    isDesktop() {
      return this.screenSize.width > 768;
    },
    tabsList() {
      if (this.navigationData) {
        return this.navigationData;
      }
      return [];
    },
    isPaymentMethodPage() {
      return this.$route.name === 'pm';
    },
  },

  methods: {
    ...mapActions(['handleSearch', 'selectCategory']),

    clickSearch() {
      console.log('Click search', this.searchIsFocus);
      this.searchIsFocus = !this.searchIsFocus;
    },

    _handleSearchUpdate(value) {
      //Skip category
      this.selectCategory('all');

      // Dispatch action
      this.handleSearch(value);

      // Update local state
      this.internalSearch = value;
    },
  },

  components: {
    InputSearchComponent,
    // TabsComponent,
    MobSearch,
    styledSelectPayment,
    TabsList,
    styledMobileNavigation,
    styledTabsWrapper,
    styledNavBarWrap,
  },
};
</script>
